import { forwardRef } from 'react';
import type { Rect } from '@/types/geometry';
import styles from './CreationPreview.module.css';

interface Props {
  readonly rect: Rect | null;
  readonly valid: boolean;
}

export const CreationPreview = forwardRef<HTMLDivElement, Props>(function CreationPreview(
  { rect, valid },
  ref,
) {
  if (!rect) return null;
  return (
    <div
      ref={ref}
      className={valid ? styles.previewValid : styles.previewInvalid}
      style={{
        left: rect.x,
        top: rect.y,
        width: rect.width,
        height: rect.height,
      }}
      aria-hidden
    />
  );
});
